"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextSep = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const context_1 = require("../../styles/context");
const h = React.createElement;
const separatorClass = (0, nano_theme_1.rule)({
    h: '1px',
    mar: '2px 0',
    w: '100%',
});
const ContextSep = ({ line, grey, small, noMargin }) => {
    const styles = (0, context_1.useStyles)();
    const light = styles.light;
    const props = {
        className: separatorClass,
        role: 'separator',
    };
    if (line) {
        props.style = {
            background: light ? styles.g(0.92) : styles.g(0.8),
        };
    }
    if (grey) {
        props.style = {
            height: small ? 3 : 7,
            margin: 0,
            background: light ? styles.g(0.985) : styles.g(0.92),
        };
    }
    if (noMargin) {
        props.style.margin = 0;
    }
    return h('div', props);
};
exports.ContextSep = ContextSep;
